export default __webpack_public_path__ + "static/media/thumb.fa6795c3.png";